module.exports = __webpack_public_path__ + "img/portifolio_militar.018e2995.jpg";